module.exports = __webpack_public_path__ + "media/images/patent/y_7-f982ea63e201606a42f66d339788b293.jpg";